export default __webpack_public_path__ + "static/media/img-slider-cmbus-admin-3.43bc2c83.png";